export default "__VITE_ASSET__BTnagZs$__"